"use strict";

exports.__esModule = true;
exports.html = void 0;
// @ts-check

/**
 * @typedef {object} ATOM
 * @property {object} atoms
 * @property {string} default
 */

var html = exports.html = {
  atoms: {
    input: {
      renderChildren: false
    },
    img: {
      renderChildren: false
    },
    path: {
      renderChildren: false,
      ui: false
    }
  },
  "default": "div"
};